module.exports = __webpack_public_path__ + "img/arrow-right-outline.d24f7063.svg";